import { cB as o, cE as r, cM as e, c as i, cNotM as n } from "./ghl-ui.es384.js";
import { fadeInScaleUpTransition as t } from "./ghl-ui.es1284.js";
const l = o("base-select-menu", `
 line-height: 1.5;
 outline: none;
 z-index: 0;
 position: relative;
 border-radius: var(--n-border-radius);
 transition:
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 background-color: var(--n-color);
`, [o("scrollbar", `
 max-height: var(--n-height);
 `), o("virtual-list", `
 max-height: var(--n-height);
 `), o("base-select-option", `
 min-height: var(--n-option-height);
 font-size: var(--n-option-font-size);
 display: flex;
 align-items: center;
 `, [r("content", `
 z-index: 1;
 white-space: nowrap;
 text-overflow: ellipsis;
 overflow: hidden;
 `)]), o("base-select-group-header", `
 min-height: var(--n-option-height);
 font-size: .93em;
 display: flex;
 align-items: center;
 `), o("base-select-menu-option-wrapper", `
 position: relative;
 width: 100%;
 `), r("loading, empty", `
 display: flex;
 padding: 12px 32px;
 flex: 1;
 justify-content: center;
 `), r("loading", `
 color: var(--n-loading-color);
 font-size: var(--n-loading-size);
 `), r("header", `
 padding: 8px var(--n-option-padding-left);
 font-size: var(--n-option-font-size);
 transition: 
 color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 border-bottom: 1px solid var(--n-action-divider-color);
 color: var(--n-action-text-color);
 `), r("action", `
 padding: 8px var(--n-option-padding-left);
 font-size: var(--n-option-font-size);
 transition: 
 color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 border-top: 1px solid var(--n-action-divider-color);
 color: var(--n-action-text-color);
 `), o("base-select-group-header", `
 position: relative;
 cursor: default;
 padding: var(--n-option-padding);
 color: var(--n-group-header-text-color);
 `), o("base-select-option", `
 cursor: pointer;
 position: relative;
 padding: var(--n-option-padding);
 transition:
 color .3s var(--n-bezier),
 opacity .3s var(--n-bezier);
 box-sizing: border-box;
 color: var(--n-option-text-color);
 opacity: 1;
 `, [e("show-checkmark", `
 padding-right: calc(var(--n-option-padding-right) + 20px);
 `), i("&::before", `
 content: "";
 position: absolute;
 left: 4px;
 right: 4px;
 top: 0;
 bottom: 0;
 border-radius: var(--n-border-radius);
 transition: background-color .3s var(--n-bezier);
 `), i("&:active", `
 color: var(--n-option-text-color-pressed);
 `), e("grouped", `
 padding-left: calc(var(--n-option-padding-left) * 1.5);
 `), e("pending", [i("&::before", `
 background-color: var(--n-option-color-pending);
 `)]), e("selected", `
 color: var(--n-option-text-color-active);
 `, [i("&::before", `
 background-color: var(--n-option-color-active);
 `), e("pending", [i("&::before", `
 background-color: var(--n-option-color-active-pending);
 `)])]), e("disabled", `
 cursor: not-allowed;
 `, [n("selected", `
 color: var(--n-option-text-color-disabled);
 `), e("selected", `
 opacity: var(--n-option-opacity-disabled);
 `)]), r("check", `
 font-size: 16px;
 position: absolute;
 right: calc(var(--n-option-padding-right) - 4px);
 top: calc(50% - 7px);
 color: var(--n-option-check-color);
 transition: color .3s var(--n-bezier);
 `, [t({
  enterScale: "0.5"
})])])]);
export {
  l as default
};
